export default __webpack_public_path__ + "static/media/logonavbar.d0211f06.png";